import { render, staticRenderFns } from "./welcome_page.vue?vue&type=template&id=cbb1b080"
import script from "./welcome_page.vue?vue&type=script&lang=js"
export * from "./welcome_page.vue?vue&type=script&lang=js"
import style0 from "./welcome_page.vue?vue&type=style&index=0&id=cbb1b080&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports